import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { CustomerSummaryTabState } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CustomerSummaryTab.state';
import { CountersComponent } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CountersComponent/CountersComponent';
import { CustomerSummaryTabCustomerData } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CustomerSummaryTabCustomerData/CustomerSummaryTabCustomerData';
import { CustomerSummaryTabSummaryOptions } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CustomerSummaryTabSummaryOptions/CustomerSummaryTabSummaryOptions';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

interface CustomerSummaryTabType {
    customerId: number;
}

export const CustomerSummaryTab = observer('CustomerSummaryTab', ({ customerId }: CustomerSummaryTabType) => {
    const common = useCommon();
    const {
        config: { pof },
    } = ConfigState.get(common);
    const { sdkStaff, models } = useAppStateContext();

    const [state] = React.useState(() => new CustomerSummaryTabState(sdkStaff, common.trpcClient, customerId, pof));

    return (
        <div className='customer-summary-tab'>
            <div className='row'>
                <div className='col-5'>
                    <CustomerSummaryTabCustomerData
                        basicCustomerData={models.getUserModel(customerId).basicData.data}
                        customerWalletData={models.getUserModel(customerId).walletData.data}
                        customerId={customerId}
                    />
                </div>
                <div className='col-7'>
                    <CustomerSummaryTabSummaryOptions
                        customerId={customerId}
                        pofWalletAggregateResource={state.pofWalletAggregateResource}
                        affordabilityStatusResource={state.affordabilityStatusResource}
                        depositLimitsResource={state.depositLimitsResource}
                        transactionTotalDepositsResource={state.transactionTotalDepositsResource}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <CountersComponent
                        customerId={customerId}
                        currency={models.getUserModel(customerId).walletData.data?.currency ?? 'XTS'}
                    />
                </div>
            </div>
        </div>
    );
});
